import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { routes } from '../common/ui/routes'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import playvsApp from '../common/state/state'
// import rotateBackground from './style/rotateBackground'
import registerAndroidScrollFix from './compat/registerAndroidScrollFix'

import 'font-awesome/css/font-awesome.css'
import 'swiper/dist/css/swiper.css'
import 'lightbox-react/style.css'
import './style/style.css'
// import 'typeface-poppins'
// import 'typeface-rajdhani'

// Browser compatibility etc
registerAndroidScrollFix()

// Setup app state (redux)
// Note: Initial state may come from server (server-side / universal rendering)
const initialState = window._INITIAL_STATE || {}

const reduxDevTools =
  (window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) || (f => f)
const store = createStore(
  playvsApp,
  initialState,
  compose(
    applyMiddleware(thunk),
    reduxDevTools
  )
)

// Deals with changing background on multiple visits
// rotateBackground()

// Mount view
const root = document.getElementById('root')

// This is a temporary React 16 hack to deal with different
// server vs client markup, need to find an elegant work-around
root.innerHTML = ''
ReactDOM.hydrate(
  React.createElement(Provider, { store }, React.createElement(BrowserRouter, null, renderRoutes(routes))),
  root
)



// WEBPACK FOOTER //
// ./src/client/client.js